import { extract_error_message } from '@/utils/api_response_helpers';
import {
  hasInvalidDependentQuestions,
  hasInvalidQuestionForms,
  resolveEditQuestionValidation,
  resolveQuestionSaveContext,
} from './create_sections_question_helpers.js';

function buildQuestionCreateValidation(ctx) {
  const question_text_error = hasInvalidQuestionForms(ctx.question_forms);
  const has_invalid_dependents = hasInvalidDependentQuestions(ctx.question_forms);
  const save_context = resolveQuestionSaveContext(ctx);
  const validation = {
    has_invalid_dependents,
    question_text_error,
    save_context,
  };
  return validation;
}

export function validateQuestionCreateRequest(ctx) {
  const validation = buildQuestionCreateValidation(ctx);
  ctx.question_text_error = validation.question_text_error;
  if (validation.question_text_error) {
    return null;
  }

  if (validation.has_invalid_dependents) {
    ctx.show_error('Please complete all required fields for dependent questions (text, type, and trigger condition).');
    return null;
  }

  if (!validation.save_context.has_context) {
    ctx.show_error('Please select a valid section first.');
    return null;
  }

  return validation.save_context;
}

export async function handleQuestionCreateSuccess(ctx, parsed_assign_response, section_id) {
  await expandRefreshedSection(ctx, section_id);

  ctx.close_modal('create_question_modal');
  ctx.show_success(
    parsed_assign_response.message || 'Questions assigned to section successfully.'
  );
}

async function expandRefreshedSection(ctx, section_id) {
  await ctx.load_form_sections();

  const refreshed_section = ctx.sections.find(
    (item) =>
      Number(item.backend_id ?? item.id ?? item.section_id) === Number(section_id)
  );

  if (refreshed_section) {
    refreshed_section.expanded = true;
  }
}

export function normalizeQuestionCrudError(error, fallback) {
  const message = extract_error_message(error, fallback);
  return message;
}

export function validateEditedQuestion(ctx) {
  const validation = resolveEditQuestionValidation(ctx.current_edit_question);
  if (!validation.has_question_id) {
    ctx.show_error('Please select a valid question first.');
    return false;
  }

  if (!validation.has_question_text) {
    ctx.show_error('Please enter a question text.');
    return false;
  }

  if (!validation.has_question_type_id) {
    ctx.show_error('Please select a question type.');
    return false;
  }

  return true;
}

export async function handleEditedQuestionSuccess(ctx, response) {
  await ctx.load_form_sections();
  const section = ctx.sections[ctx.active_edit_section_index];
  if (section) {
    section.expanded = true;
  }
  ctx.close_modal('edit_question_modal');
  ctx.show_success(response.message || 'Question updated successfully.');
}

